import { render, staticRenderFns } from "./CustomFontFamilies.vue?vue&type=template&id=ddef238a&"
import script from "./CustomFontFamilies.vue?vue&type=script&lang=ts&"
export * from "./CustomFontFamilies.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFontFamilies.vue?vue&type=style&index=0&id=ddef238a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports